import { useState, useEffect } from "react";
import { Box, Grid, Button, Typography } from "@mui/material";
import GetSites from "../../components/api/GetSites";
import stockimage from "../../img/stockbuilding.jpeg"
import buildingoffline from "../../img/building-disabled.webp"
import RoofingIcon from '@mui/icons-material/Roofing';
import PlaceIcon from '@mui/icons-material/Place';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import LeafletMap from "../../components/LeafletMap";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import GetImage from "../../components/api/GetImage";
import GetUser from '../../components/api/GetUser'
import LoginCookieAuth from "../../components/api/LoginCookieAuth";
import { useSite } from "../../components/siteselector/SiteContext";
import InfLoader from '../../components/infLoad/'

const Home = () => {
  const [siteData, setSiteData] = useState([]);
  const [showMap, setMap] = useState(false);
  const navigate = useNavigate();
  const [userData, setUserData] = useState('')
  const [images, setImages] = useState([]);
  const { selectedSite, setSelectedSite } = useSite();

  // Checks user authtoken and gets all sites and set list with proj images
  useEffect(() => {
    LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async(authResponse) => {
      if(authResponse) {
        GetSites().then(async (response) => {
          await GetUser().then((response) => {
            if (response['data']['rows'].length !== 0) {
              setUserData(response.data["rows"][0])
            }
          })
          const responseVal = response.data['rows'];  
          setSiteData(responseVal);
          navigate(`/projects/${responseVal[0].id.val}`)
          setSelectedSite(responseVal[0].id.val)
          const promises = Object.entries(responseVal).map(([key, value]) => {
            if (value.infSiteImageUri) {
              const imgBase64 = GetImage(value.infSiteImageUri.val)
              value = imgBase64
              return value
            }
            return null
          });
          const imageList = await Promise.all(promises)
          setImages(imageList)
        })
      }
    })
    console.log(selectedSite)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  // When pressed navigate user to buildings location on googlemaps
  function getMapsLink(site = []) {
    const address = site.geoStreet + "," + site.geoPostalCode;
    const addressEncode = encodeURIComponent(address);
    window.open('https://www.google.com/maps/search/?api=1&query=' + addressEncode);
  }

  // Set cookie & selected site and navigate to building overview
  const setCookieAndNavigate = (siteId) => {
    setSelectedSite(siteId)
    navigate(`/projects/${siteId}/buildingoverview`);
  };

  // Creates a card for a site with the data and the index for the image
  const CreateCard = (siteData, siteIndex) => {
    // Create card with site data if the project is online
    if(siteData.infSiteOnlineStatus === true) {
      return (
        <Grid item xl={3} lg={4} md={6} sm={12} xs={12} key={siteData.id.val}>
          <Card style={{ height: { xl: '410px' }, display: "flex", flexDirection: "column"}} key={siteData.id.val} square={true}>
            <CardMedia
              image={siteData.infSiteImageUri ? images[siteIndex] : stockimage}
              onClick={() => setCookieAndNavigate(siteData.id.val)}
              title={siteData.id.dis}
              style={{ 
                paddingTop: '56.25%', 
                cursor:'pointer',
                outlineOffset: '-5px',
              }}
              component='div'
            />
            <CardContent style={{ flexGrow: 1 }}>
              <Typography sx={{color:'#141414'}} fontWeight='bold' variant="h4">{siteData.navName}</Typography>
            </CardContent>
            <CardActions>
              <Button size="medium" variant="contained" style={{backgroundColor:'#f2f0f0', color:'#141414', textTransform:'none'}} startIcon={<RoofingIcon style={{color:'#141414'}}/>} onClick={() => setCookieAndNavigate(siteData.id.val, siteData.id.dis)}>Bekijk gebouw overzicht</Button>
              <Button size="medium" variant="contained" style={{backgroundColor:'#f2f0f0', color:'#141414', textTransform:'none'}} startIcon={<PlaceIcon style={{color:'#141414'}}/>} onClick={() => getMapsLink(siteData)} >Open locatie op Google Maps</Button>
            </CardActions>
          </Card>
        </Grid>
      )
      // If infSiteOnlineStatus is false render card with project offline and make card disabled  
    } else if (siteData.infSiteOnlineStatus === false) {
      return (
          <Grid item xl={3} lg={4} md={6} sm={12} xs={12} key={siteData.id.val}>
            <Card style={{ height: { xl: '410px' }, display: "flex", flexDirection: "column", cursor: 'not-allowed', opacity:0.5}} key={siteData.id.val} square={true}>
              <CardMedia
                image={buildingoffline}
                title={siteData.id.dis}
                style={{ 
                  paddingTop: '56.25%', 
                  outlineOffset: '-5px',
                }}
                component='div'
              />
              <CardContent style={{ flexGrow: 1 }}>
                <Typography sx={{color:'#141414'}} fontWeight='bold' variant="h4">{siteData.navName} (offline)</Typography>
              </CardContent>
              <CardActions>
                <Button size="medium" variant="disabled" style={{backgroundColor:'#f2f0f0', color:'#141414', textTransform:'none'}} startIcon={<RoofingIcon style={{color:'#141414'}}/>} onClick={() => setCookieAndNavigate(siteData.id.val, siteData.id.dis)}>Bekijk gebouw overzicht</Button>
                <Button size="medium" variant="disabled" style={{backgroundColor:'#f2f0f0', color:'#141414', textTransform:'none'}} startIcon={<PlaceIcon style={{color:'#141414'}}/>} onClick={() => getMapsLink(siteData)} >Open locatie op Google Maps</Button>
              </CardActions>
            </Card>
          </Grid>
      )
    }
  }

  return (
    <>
      <Box m="18px">
        <Button variant="contained" style={{backgroundColor:'#f2f0f0', textTransform:'none', color:'#141414'}} onClick={() => setMap(!showMap)}>{
          showMap ? (
            "Lijstweergave"
          ) : (
            "Kaartweergave"
          )
        }</Button>
        {
          showMap ? (
            <Box sx={{ marginTop: '40px' }}>
              <LeafletMap coordinates={siteData} />
            </Box>
          ) : (
            <Grid container spacing={4} sx={{ marginTop: '5px', marginRight: '5px' }}>
              {
                // Check if siteData variable & image list are not 0
                siteData.length !== 0 && images.length !== 0 ? (
                  // Checks if user is a superuser OR admin, if true render the sites without projacces filter
                  (userData.projAccessFilter === undefined && userData.userRole === 'su') || userData.userRole === 'admin' ? (
                    siteData.map((site, index) => (
                      CreateCard(site, index)
                  ))
                  ) : (
                    // If user is NOT a superuser OR admin use the projaccesfilter to render the sites available 
                    siteData.map((site, index) => (
                      userData.projAccessFilter.includes(site['id']['val'].split(':')[1]) ? (
                          CreateCard(site, index)
                        ) : (
                          <>
                          </>
                        )
                  ))
                  )
                ) : (<Box sx={{width:'100%', height:'900px', display:'flex', alignItems:'center', justifyContent:'center'}}><InfLoader/></Box>)
              }
            </Grid>
          )
        }
      </Box>
    </>
  );
}

export default Home;

